// Service worker-i YALNIZ "Offline rejim" tikli tenantda qeyd edir (demo). Flag sönülüdürsə və ya
// kill-switch aktivdirsə → mövcud SW-ni unregister edir (digər tenantlara sıfır təsir).
// Kill-switch: konsolda window.__swKill() → SW silinir + keş təmizlənir.

const graceOffline = () => {
    try {
        const g = JSON.parse(localStorage.getItem('pos_license_grace') || 'null');
        return !!(g && g.offline);
    } catch { return false; }
};
const killed = () => { try { return localStorage.getItem('pos_sw_kill') === '1'; } catch { return false; } };

const unregisterAll = () => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister())).catch(() => {});
    if (typeof caches !== 'undefined') caches.keys().then((ks) => ks.forEach((k) => caches.delete(k))).catch(() => {});
};

export function maybeRegisterOfflineSW() {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

    // Kill-switch — konsoldan: __swKill()
    window.__swKill = () => {
        try { localStorage.setItem('pos_sw_kill', '1'); } catch { /* ignore */ }
        unregisterAll();
        return 'Offline SW öldürüldü və keş təmizləndi — səhifəni yeniləyin.';
    };
    window.__swRevive = () => {
        try { localStorage.removeItem('pos_sw_kill'); } catch { /* ignore */ }
        return 'Kill-switch söndürüldü — offline tenant üçün növbəti yükləmədə SW qeyd olunacaq.';
    };

    if (killed() || !graceOffline()) {
        unregisterAll(); // flag yoxdur / kill → heç bir SW qalmasın
        return;
    }

    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/offline-sw.js').catch(() => { /* səssiz */ });
    });
}
